export default __webpack_public_path__ + "34722714eeb9657a01360434b092e57a.png";